<template>
  <div class="drug-box">
    <img src="https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/bluetooth/1.png" alt="">
    <img src="https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/bluetooth/2.png" alt="">
<!--    <img @click="goBack" class="btn" src="https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/bluetooth/3.png" alt="">-->
  </div>
</template>
<script>

export default {
  data () {
    return {
      isApp: false,
      sourceApp: null,
      showShareIcon: false,
      showShare: false
    }
  },
  created () {
  },
  methods: {
    goBack () {
      dsBridge.call('callCloseCurView', {})
    }
  }
}
</script>
<style lang="scss" scoped>
.drug-box {
  box-sizing: border-box;
  min-height: 100vh;
  font-size: 0;
  img {
    width: 100%;
  }
  .btn {
    width: 92%;
    margin-bottom: 5%;
    margin-left: 4%;
  }
}
.img-item {
  position: relative;
  img {
    width: 100%;
  }
}
.img-item-2 {
  position: fixed;
  bottom: 0.5%;
  margin: 10px 0;
  padding: 0 10%;
  img {
    width: 100%;
  }
}
</style>
